import { Box, Button, Typography } from "@mui/material";
import { AppDialog } from "AttendanceForm/Components/Dialog/Dialog";
import { useTranslation } from "react-i18next";

interface CheckSubmissionModallProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  eventName: string;
  eventDate: string;
}

export const CheckSubmissionModal = ({
  isOpen,
  onClose,
  onSubmit,
  eventName,
  eventDate,
}: CheckSubmissionModallProps) => {
  const { t } = useTranslation("learnerDetailsForm");
  const { t: tcommon } = useTranslation("common");

  return (
    <AppDialog
      id="checkSubmissionModal"
      maxWidth="md"
      open={isOpen}
      title={tcommon("attendanceConfirm")}
      onCloseHandler={onClose}
    >
      <Typography gutterBottom>{t("checkSubmission")}</Typography>

      <Box paddingTop={2} paddingBottom={2}>
        <Typography id="event-name-id" gutterBottom>
          <strong>{tcommon("eventName")} </strong> {"'" + eventName + "'"}
        </Typography>
        <Typography id="event-date-id" gutterBottom>
          <strong>{tcommon("eventDate")} </strong> {eventDate}{" "}
        </Typography>
      </Box>

      <Typography gutterBottom>{t("submitWarning")}</Typography>
      <Typography gutterBottom>{t("proceedPopupHelper")}</Typography>
      <Box display="flex" justifyContent="flex-end" paddingTop={2}>
        <Box paddingRight={2}>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {tcommon("submit")}
          </Button>
        </Box>
        <Button variant="contained" color="primary" onClick={onClose}>
          {tcommon("cancel")}
        </Button>
      </Box>
    </AppDialog>
  );
};
